import React from 'react';
import { FaWhatsapp, FaMapMarkerAlt, FaPhone, FaCar, FaCog, FaWrench } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
          <path fill="#1a1a2e" fillOpacity="1" d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,64C960,75,1056,85,1152,80C1248,75,1344,53,1392,42.7L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
        </svg>
      </div>
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <FaCar className="logo-icon" />
              <h3>SPARE PARTS</h3>
            </div>
            <p>Your trusted partner for quality automotive spare parts in Kuwait. Powered by an intelligent WhatsApp booking system.</p>
            <div className="footer-social">
              <a href="https://wa.me/13613143794" className="social-link whatsapp" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#services">Our Services</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="https://wa.me/13613143794" target="_blank" rel="noopener noreferrer">Order Parts</a></li>
              <li><a href="https://wa.me/13613143794" target="_blank" rel="noopener noreferrer">Get a Quote</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><FaCog className="list-icon" /> Engine Parts</li>
              <li><FaWrench className="list-icon" /> Body Parts</li>
              <li><FaCar className="list-icon" /> Electrical Parts</li>
              <li><FaCog className="list-icon" /> Suspension Parts</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div>
                <p>South Nuqra, Hawalli</p>
                <p>Hawalli, Kuwait 00000</p>
                <p>Kuwait</p>
              </div>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div>
                <a href="tel:+13613143794">+1 (361) 3143794</a>
              </div>
            </div>
            <div className="contact-item">
              <FaWhatsapp className="contact-icon whatsapp-icon" />
              <div>
                <a href="https://wa.me/13613143794" target="_blank" rel="noopener noreferrer">
                  WhatsApp Us
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SPARE PARTS. All rights reserved.</p>
          <p>Powered by WhatsApp Automation</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




